import { __extends } from "tslib";
import Plot from '../base/plot';
import { deepMix } from '@antv/util';
var ComboPlot = /** @class */ (function (_super) {
    __extends(ComboPlot, _super);
    function ComboPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComboPlot.prototype.getDefaultOptions = function () {
        return {};
    };
    ComboPlot.prototype.getGlobalOptions = function (props) {
        return {
            xAxis: props.xAxis,
            yAxis: props.yAxis,
            theme: props.theme,
            legend: props.legend,
        };
    };
    ComboPlot.prototype.createComboLayers = function () {
        this.globalOptions = deepMix({}, this.getDefaultOptions(), this.getGlobalOptions(this.options));
    };
    return ComboPlot;
}(Plot));
export default ComboPlot;
//# sourceMappingURL=base.js.map